<template>
    <tr v-on:click.stop="showTrip()" class="form-summary" v-bind:class="{'text-cancelled' : isBookingCancelled}">
        <td>{{friendlyDate(formResponse.created)}}</td>
        <td class="form-summary__guest-name">{{formResponse.booking.bookedBy.firstName}} {{formResponse.booking.bookedBy.lastName}}</td>
        <td>{{formResponse.title}}</td>
        <td>{{friendlyDate(formResponse.booking.arrival)}}</td>
        <td>{{friendlyDate(formResponse.booking.departure)}}</td>
        <td class="tabular__actions">
            <template v-if="waiting">
                <div class="form-summary__waiting">
                    <Spinner/>
                </div>
            </template>
            <div v-else-if="actionError" class="tooltip-container d-inline">
                <i class="fas fa-times form-summary__action-error" v-on:mouseenter="showActionErrorTooltip = true" v-on:mouseleave="showActionErrorTooltip = false"></i>
                <tooltip v-bind:visible="showActionErrorTooltip" v-bind:position="'bottom'" v-bind:text="actionErrorTooltip"></tooltip>
            </div>
            <template v-else>
                <div v-if="!isBookingCancelled" v-on:click.stop="openFormResponse" class="tooltip-container d-inline">
                    <button class="btn-small">
                        <i class="fas" v-bind:class="actionIcon" v-on:mouseenter="showTooltip = true" v-on:mouseleave="showTooltip = false" aria-hidden="true"></i>
                    </button>
                    <tooltip v-bind:visible="showTooltip" v-bind:position="'bottom'" v-bind:text="actionTooltip"></tooltip>
                </div>
                <div v-if="isFormResponseComplete" v-on:click.stop="confirmEmailPDFOfCompletedForm" class="tooltip-container d-none d-sm-inline">
                    <button class="btn-small">
                        <div class="task-icon">
                            <i class="far fa-file-pdf" v-on:mouseenter="showPDFTooltip = true" v-on:mouseleave="showPDFTooltip = false"></i>
                            <i class="fas fa-envelope task-state task-state--scheduled" aria-hidden="true"></i>
                        </div>
                    </button>
                    <tooltip v-bind:visible="showPDFTooltip" v-bind:position="'bottom-left'" v-bind:text="'Email yourself a PDF copy of this form'"></tooltip>
                    <confirm-dialog v-bind:message="confirmEmailPDFMessage" v-bind:callbackPrimaryName="'email-pdf'" v-bind:callbackPrimaryReference="formResponse.reference" v-if="showConfirmPDFDialog"/>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>
    import {store} from '../../store.js'

    import Spinner from '../Spinner.vue'
    import Tooltip from '../Tooltip.vue'
    import ConfirmDialog from '../ConfirmDialog.vue'

    import {datesMixin} from "../../mixins/DatesMixin"

    export default {
        name: "FormSummary.vue",
        components: { Spinner, Tooltip, ConfirmDialog },
        mixins: [datesMixin],
        props: {
            index: Number,
            formResponse: Object
        },
        data: function () {
            return {
                showTooltip: false,
                showPDFTooltip: false,
                showActionErrorTooltip: false,
                showConfirmPDFDialog: false,
                waiting: false,
                actionError: false,
                actionErrorTooltip: "",
            }
        },
        computed: {
            actionIcon: function () {
                if (this.formResponse.completed) {
                    return 'fa-check task-done'
                } else {
                    return 'fa-edit'
                }
            },
            actionTooltip: function () {
                if (this.formResponse.completed) {
                    return 'View'
                } else {
                    return 'Edit'
                }
            },
            isBookingCancelled: function() {
                const state = String(this.formResponse.booking.state)
                return state === 'cancelled'
            },
            isFormResponseComplete: function() {
                if (this.formResponse.completed) {
                    return true
                } else {
                    return false
                }
            },
            confirmEmailPDFMessage: function() {
                return "Are you sure you want to <b>email yourself a PDF</b> of the the completed form for the booking for <b>" +
                    this.formResponse.booking.bookedBy.firstName + " " + this.formResponse.booking.bookedBy.lastName + "?</b>";
            }
        },
        methods: {
            openFormResponse: function () {
                this.$router.push({ name: 'ViewForm', params: { reference: this.formResponse.reference } })
            },
            showTrip: function() {
                this.$root.$emit('show-trip', this.formResponse.booking);
            },
            confirmEmailPDFOfCompletedForm: function() {
                this.showConfirmPDFDialog = true;
            },
            emailPDFOfCompletedForm: function(reference) {
                this.showConfirmPDFDialog = false;
                if (this.formResponse.reference === reference) {
                    this.waiting = true;
                    this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference +
                        '/form-responses/' + this.formResponse.reference +
                        '/email-completed-pdf-to-host').then(() => {
                    }).catch(error => {
                        this.actionError = true;
                        if (error && error.response && error.response.data && error.response.data.message) {
                            this.actionErrorTooltip = error.response
                        } else {
                            this.actionErrorTooltip = 'Problem sending PDF of form'
                        }
                    }).finally(() => {
                        this.waiting = false;
                    })
                }
            },
        },
        mounted() {
            this.$root.$on('email-pdf', this.emailPDFOfCompletedForm);
        },
        beforeDestroy() {
            this.$root.$off('email-pdf', this.emailPDFOfCompletedForm);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/layout/tabular";
    @import "../../styles/components/form_summary";
    @import "../../styles/components/task";
</style>